import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Chip,
  Grid,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";

const DailyLogWitnessManager = ({ nextStep, witnessData }) => {
  const user = useSelector((state) => state.auth.user); // User witnessData from Redux store

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Incident Management</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#333", mb: 2 }}>
            Witness to Intervention
          </Typography>

          {/* Table */}
          <TableContainer component={Paper} elevation={3}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#E3F2FD" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Involved/Witness</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Adult/Child</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {witnessData?.map((witness, index) => (
                  <TableRow key={index}>
                    <TableCell>{witness.name}</TableCell>
                    <TableCell>{witness.role}</TableCell>
                    <TableCell sx={{ color: "#333" }}>{witness.category}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            nextStep(); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default DailyLogWitnessManager;
